import { Star } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface Review {
  id: string;
  name: string;
  event: string;
  text: string;
  rating: number;
}

const ReviewsSection = () => {
  const { data: reviews = [] } = useQuery({
    queryKey: ["landing_reviews_public"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("landing_reviews")
        .select("*")
        .eq("is_active", true)
        .order("sort_order");
      if (error) throw error;
      return data as Review[];
    },
    staleTime: 5 * 60 * 1000,
  });

  if (reviews.length === 0) return null;

  return (
    <section className="py-12 relative" id="reviews">
      <div className="container px-4 mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold mb-3 text-foreground">
            Отзывы <span className="text-gradient-primary">пользователей</span>
          </h2>
          <p className="text-muted-foreground text-base max-w-md mx-auto">
            Более 12 000 хитов уже создано
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {reviews.map((review) => (
            <article key={review.id} className="p-6 rounded-2xl bg-card border border-border">
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-accent text-accent" />
                ))}
              </div>
              <p className="text-foreground mb-4 leading-relaxed text-sm">«{review.text}»</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-sm">
                  {review.name[0]}
                </div>
                <div>
                  <p className="font-medium text-sm text-foreground">{review.name}</p>
                  <p className="text-muted-foreground text-xs">{review.event}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
